export enum ConnectionMode {
  IP = '1',
  X25PstnPad = '3',
}
